export const ADDRESS_BOOK_CONTACT_TYPE_FILTER = {
  JOINED_ONLY: 'JOINED_ONLY',
  CONTACTS_ONLY: 'CONTACTS_ONLY',
};

export const ADDRESS_BOOK_CONTACT_TYPE_FILTER_LABEL = {
  [ADDRESS_BOOK_CONTACT_TYPE_FILTER.JOINED_ONLY]: 'Joined Users',
  [ADDRESS_BOOK_CONTACT_TYPE_FILTER.CONTACTS_ONLY]: 'Linked Contacts',
};
